import React, { Component, useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch, useStore } from 'react-redux';
// import store from 'app/store';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function WizardDialog ( props ) {
    const {
        title = 'Wizard',
        open,
        panel, // the component to embed
        onPrevious,
        onNext,
        onSave,
        onCancel,
        previousHide=false,
        nextHide=false,
        previousEnable=true,
        nextEnable=true,
        okEnabled=false,
        okLabel='OK',
        cancelLabel='Cancel',
        previousLabel='Previous',
        nextLabel='Next',
        errorMessage='',
        errorEnable=false,
        ...other
    } = props;

    const onPreviousClick = () => {
        if ( typeof onPrevious === 'function') {
            onPrevious();
        }
    };

    const onNextClick = () => {
        if ( typeof onNext === 'function' ) {
            onNext();
        }
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const onCancelClick = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave();
        }
    }

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 1200,
                        maxWidth: 1200,
                        minHeight: 900
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', paddingTop: '2ex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="outlined" onClick={onPreviousClick} disabled={!previousEnable}
                    sx={{ minWidth: '9.5em', visibility: previousHide ? 'hidden' : 'visible' }} 
                    startIcon={<ArrowBackIosIcon />}>{previousLabel}</Button>
                    <Button variant="outlined" onClick={onNextClick} 
                    sx={{ minWidth: '9.5em', visibility: nextHide ? 'hidden' : 'visible' }} 
                    disabled={!nextEnable} 
                    endIcon={<ArrowForwardIosIcon />}>{nextLabel}</Button>
                </Box>
                {panel}
            </DialogContent>
            <DialogActions sx={{ padding: 3, display: 'flex', justifyContent: 'space-between' }}>
                <Typography color="warning" sx={{visibility: errorEnable ? 'visible' : 'hidden'}}>{errorMessage}</Typography>
                <Box>
                    <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >{okLabel}</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>{cancelLabel}</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );

}

export { WizardDialog };